module.exports = __webpack_public_path__ + "static/6invgde-767685d4e3937e671acab5a79f709947.gif";